import React from "react";
import {Button} from "antd";

const AccountClose = () => {
    const onClick = (e: React.MouseEvent) => {
        e.preventDefault();

        const mailTo = encodeURIComponent(window.env.CLIENT_MAILBOX);
        const subject = encodeURIComponent('Account Closure Request');

        window.location.href = `mailto:${mailTo}?subject=${subject}`;
    };

    return <Button danger htmlType="button" onClick={onClick}>Request Account Closure</Button>
}

export default AccountClose;
